import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { HiOutlineBuildingOffice2 } from 'react-icons/hi2';
import SectionCard from '../../../components/common/SectionCard/SectionCard';
import { dropdownWithSuffix, DROPDOWN_CLIENT, DROPDOWN_OFFICE } from '../../../constants/testIds';
import { REACT_APP_URL_V2_CLIENT_FIND_ALL } from '../../../components/common/Routes/URLs';
import useFetchOfficeList from '../../../Hooks/fetch/useFetchOfficeList';
import useLookupOptions from '../../../Hooks/fetch/useLookupOptions';
import { BACKEND_IDS } from '../../../services/ApiConfig';
import PortalLookupDropdown from './PortalLookupDropdown';
import { isClientRole } from './Schema';

const CLIENT_ID_KEYS = ['clientId'];
const CLIENT_LABEL_KEYS = ['clientName', 'name'];
const CLIENT_LOOKUP = {
  label: 'com.tempedge.msg.label.client',
  field: 'clientId',
  nameField: 'clientName',
  idKey: 'id',
  textKey: 'label',
  testIdBase: DROPDOWN_CLIENT
};
const OFFICE_LOOKUP = {
  label: 'com.tempedge.msg.label.office',
  field: 'officeId',
  nameField: 'officeName',
  idKey: 'officeId',
  textKey: 'name',
  testIdBase: DROPDOWN_OFFICE
};

const PortalAccessFields = ({ portalUserList = [], onPortalChange }) => {
  const { offices } = useFetchOfficeList();
  const hasClientRole = portalUserList.some((portal) => isClientRole(portal.role));
  const clients = useLookupOptions(hasClientRole, {
    url: REACT_APP_URL_V2_CLIENT_FIND_ALL,
    backendType: BACKEND_IDS.BACKEND_2,
    idKeys: CLIENT_ID_KEYS,
    labelKeys: CLIENT_LABEL_KEYS
  });

  const getLookupProps = (portal, index) => {
    const isClient = isClientRole(portal.role);
    const lookup = isClient ? CLIENT_LOOKUP : OFFICE_LOOKUP;
    return {
      label: lookup.label,
      name: `portalUserList[${index}].${lookup.field}`,
      options: isClient ? clients : offices || [],
      idKey: lookup.idKey,
      textKey: lookup.textKey,
      currentId: portal[lookup.field],
      currentText: portal[lookup.nameField],
      testId: dropdownWithSuffix(lookup.testIdBase, index),
      onChange: (value) => onPortalChange(index, { [lookup.field]: value[lookup.idKey], [lookup.nameField]: value[lookup.textKey] })
    };
  };

  return (
    <Row>
      {portalUserList.map((portal, index) => (
        <Col key={portal.portalUserConfId ?? portal.orgName} sm={12} md={6} lg={6} className="mb-3">
          <SectionCard
            testId={`portal-access-row-${index}`}
            icon={<HiOutlineBuildingOffice2 aria-hidden="true" />}
            title={portal.orgName}
            subtitle={portal.role?.description}
          >
            <PortalLookupDropdown {...getLookupProps(portal, index)} />
          </SectionCard>
        </Col>
      ))}
    </Row>
  );
};

export default PortalAccessFields;
